import { ArrowRight } from 'lucide-react';
import './Hero.css';

export default function Hero({ 
  eyebrow = "Cloud Platforms", 
  title, 
  description, 
  primaryAction, 
  secondaryAction,
  stats
}) {
  return (
    <section className="hero" aria-labelledby="hero-heading">
      <div className="hero-visuals" aria-hidden="true">
        <span className="hero-orb orb-one"></span>
        <span className="hero-orb orb-two"></span>
        <span className="hero-orb orb-three"></span>
        <span className="hero-orb orb-four"></span>
      </div>

      <div className="hero-copy">
        <span className="eyebrow">{eyebrow}</span>
        <h1 id="hero-heading">
          {title || (
            <>
              Build, Scale <span className="hero-accent">& Secure</span>
              <br /> on Cloud.
            </>
          )}
        </h1>
        <p>
          {description || "VanByte Technologies delivers modern cloud architectures with high-performance operations, secure multi-cloud deployments, and automated workflows designed for evolving enterprise needs."}
        </p>

        <div className="hero-actions">
          <a className="button button-primary" href={primaryAction?.link || "#services"}>
            {primaryAction?.label || "Start Your Journey"}
            <ArrowRight size={18} className="button-icon" />
          </a>
          <a className="button button-secondary" href={secondaryAction?.link || "#cta"}>
            {secondaryAction?.label || "Book Consultation"}
            <ArrowRight size={18} className="button-icon" />
          </a>
        </div>

        <div className="hero-stat-grid">
          {stats ? stats.map((stat, i) => (
            <div key={i} className="hero-stat">
              <strong>{stat.label}</strong>
              <span>{stat.value}</span>
            </div>
          )) : (
            <>
              <div className="hero-stat">
                <strong>Trusted by enterprise teams</strong>
                <span>for resilient cloud delivery.</span>
              </div>
              <div className="hero-stat">
                <strong>Multi-cloud readiness</strong>
                <span>AWS, Azure, and Google Cloud platforms.</span>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="hero-frame">
        <div className="hero-illustration">
          <img
            src="/images/cloud/hero-cloud.webp"
            alt="Cloud infrastructure illustration"
          />
        </div>
      </div>
    </section>
  );
}
